// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"895a3391","16":"f27f0148","73":"a8014dc9","139":"2136bfdc","179":"db7d4f54","203":"313bd1b6","282":"9529f702","606":"ef58e5cc","617":"786ccfa7","636":"d7fc839f","637":"61c5c443","671":"b6a163f2","857":"370fcd69","865":"0e3938be","947":"4ac34ca0","981":"9455f24f"}[chunkId] + ".chunk.js";
};